import { render, staticRenderFns } from "./AdvertisersTable.vue?vue&type=template&id=334d4b9d&"
import script from "./AdvertisersTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AdvertisersTable.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AdvertisersTable.vue?vue&type=style&index=0&id=334d4b9d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports